/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import PropTypes from 'prop-types';

export const ArrowIcon = ({width = 16, height = 16, color, direction = 'left', mode = 'light'}) => {
  const isLeft = direction === 'left';
  const iconColor = color || (mode === 'dark' ? '#fff' : '#000');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      style={{ display: 'block', ...(isLeft ? { transform: 'rotate(180deg)' } : {}) }}
    >
      <path
        d="M13.4584 18.621L11.979 17.1417L14.5998 14.5208H8.14585V12.3958H14.5998L11.979 9.775L13.4584 8.29564L18.621 13.4583L13.4584 18.621ZM13.4559 26.9167C15.3174 26.9167 17.0671 26.5634 18.705 25.857C20.3429 25.1506 21.7676 24.1918 22.9791 22.9808C24.1905 21.7698 25.1497 20.3457 25.8567 18.7085C26.5633 17.0713 26.9167 15.3221 26.9167 13.4608C26.9167 11.5993 26.5635 9.84961 25.857 8.21171C25.1506 6.5738 24.1918 5.14911 22.9808 3.93762C21.7698 2.72614 20.3457 1.76694 18.7085 1.06002C17.0713 0.35334 15.3221 0 13.4608 0C11.5993 0 9.84963 0.353222 8.21173 1.05967C6.57383 1.76611 5.14913 2.72484 3.93764 3.93585C2.72616 5.14687 1.76696 6.57097 1.06004 8.20817C0.353361 9.84536 2.09808e-05 11.5946 2.09808e-05 13.4559C2.09808e-05 15.3174 0.353243 17.0671 1.05969 18.705C1.76613 20.3429 2.72486 21.7676 3.93587 22.979C5.14689 24.1905 6.57099 25.1497 8.20819 25.8566C9.84538 26.5633 11.5946 26.9167 13.4559 26.9167ZM13.4584 24.7917C10.2945 24.7917 7.6146 23.6938 5.41877 21.4979C3.22294 19.3021 2.12502 16.6222 2.12502 13.4583C2.12502 10.2944 3.22294 7.61458 5.41877 5.41875C7.6146 3.22292 10.2945 2.125 13.4584 2.125C16.6222 2.125 19.3021 3.22292 21.4979 5.41875C23.6938 7.61458 24.7917 10.2944 24.7917 13.4583C24.7917 16.6222 23.6938 19.3021 21.4979 21.4979C19.3021 23.6938 16.6222 24.7917 13.4584 24.7917Z"
        fill={iconColor}
      />
    </svg>
  );
};

ArrowIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  direction: PropTypes.oneOf(['left', 'right']),
  mode: PropTypes.string
};

export const LeftArrowIcon = (props) => <ArrowIcon direction="left" {...props} />;
export const RightArrowIcon = (props) => <ArrowIcon direction="right" {...props} />;

